import { Injectable } from '@angular/core';

import { BaseService } from 'tms-lib';

@Injectable({
  providedIn: 'root',
})
export abstract class TmsWebBaseService extends BaseService {
  protected constructor(baseRoute: string) {
    super(baseRoute);
  }

  protected get apiUrl() {
    return `TmsWeb/${this.baseRoute}`;
  }
}
